import { render } from "./response.vue?vue&type=template&id=94715040"
import script from "./response.vue?vue&type=script&lang=js"
export * from "./response.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__